module.exports = __webpack_public_path__ + "img/24_38.3e676f6f.png";